/*  英文包  */
import ptLocale from 'element-ui/lib/locale/lang/pt'
const ptyy = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'Disco na nuvem',
        'headerlangSelect' : 'Por favor selecione um idioma',
        'headerLoginOut' : 'Sair',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'Todos os arquivos',
        'sideMenuPhoto' : 'Imagens',
        'sideMunsDoc' : 'Ficheiro',
        'sideMenuVideo' : 'Vídeo',
        'sideMenuSeed' : 'Semente',
        'sideMenuMusic' : 'Música',
        'sideMenuOrther' : 'Outros',
        'sideMenuShareName' : 'Minha parte',
        'sideMenuCollectName' : 'Lixeira',

        /*  用户语言设定 */
        'mainUpload' : 'Carregar',
        'mainBuildDir' : 'Nova pasta',
        'mainDownloadOutline' : 'Download offline',
        'mainSearch' : 'Pesquisa de arquivo',
        'mainAllFile' : 'Todos os arquivos',
        'mainFile' : 'Ficheiro',
        'mainSize' : 'Tamanho',
        'mainDate' : 'Data',
        'mainFileDel' : 'Excluir',
        'mainConfirmDel' : 'Confirmar exclusão?',
        'sure' : 'Confirme',
        'cancel' : 'Cancelar',
        'mainReturn' : 'Voltar para',
        'mainPagePrev' : 'Anterior',
        'mainPageNext' : 'Página seguinte',
        'mainLoaded' : 'Carregado',
        'mainTotal' : 'Total',
        'mainUnit' : 'Strip',
        'dilatation' : 'Expansão',
        /*  回收站设定  */
        'mainHeaderTitle' : 'Dica: A lixeira não ocupa espaço em disco da rede.',
        'mainHeaderButton' : 'Lixeira vazia',
        'collectName' : 'Lixeira',
        'mainRevertIts' : 'Restaurar',
        'mianDelData' : 'Excluir tempo',

        'confirmClear' : 'Confirmar para limpar os arquivos selecionados? (Não é possível recuperar após a limpeza)',
        'confirmClearAll' : 'Tem certeza de que deseja esvaziar a lixeira?',

        /*  其他设定 */
        'messageBoxTitle' : 'Sugestão',
        'messageBoxConfirmRevert' : 'Confirmar para restaurar o arquivo selecionado?',
        'loading' : 'Carregando ...',
        'loaded' : 'Sem dados',

        'messageMoveTo' : 'Mover para',
        'filterNotice' : 'Digite palavras-chave para filtrar',
        'messageLoaded' : 'Transferido:',
        'messageMovetion' : 'Mover arquivo',

        'messageMissKeyWord' : 'Digite as palavras-chave de pesquisa',
        'messageFolderLayersLimit' : 'Falha na criação A profundidade da hierarquia de pastas não excede 5 níveis',
        'messageSameFolderName' : 'Falha na criação O mesmo nome de arquivo existe',
        'messageEmptyFolderName' : 'Digite um nome de pasta',
        'messageMoveSame' : 'Não é possível mover para a mesma pasta',
        'messageActionError' : 'Falha na operação',
        'messageActionSuccess' : 'Operação bem sucedida',
        'messageServerIsBusy' : 'O servidor está ocupado',
        'messageUploadOverLimit' : 'Muitos arquivos selecionados (dentro de 5)',
        'messageDiskFreeFull' : 'Espaço insuficiente do usuário',
        'messageUploadTypeError' : 'Não foi possível fazer o upload deste tipo de arquivo',
        'messageUploadMaxSize' : 'O arquivo de upload é muito grande (dentro de 10 milhões)',
        'messageUploadSuccess' : 'Carregado com sucesso',
        'messageUploadFailed' : 'Falha no upload',
        'messageDownloadFailed' : 'Falha no download'
    },
    ...ptLocale
};

export default ptyy;



// WEBPACK FOOTER //
// ./src/i18n/langs/ptyy.js